const createCartList = (cart: any) => {
  return cart
    .map((element: any, index: number) => {
      const product = {
        style: { marginBottom: "5px", marginTop: "8px" },
        texts: [
          {
            style: {
              fontWeight: 500,
            },
            text: `${index + 1}. (${element.cart_positoin.meal_quantity}x) ${element.cart_positoin.meal_name
              }`,
          },
        ],
        price: element.cart_positoin.meal_price,
        quantity: element.cart_positoin.meal_quantity,
        productId: element.cart_positoin.meal_id,
      };
      const addidton = element.cart_positoin.meal_options
        .flatMap((e: any, sectionIndex: number) => {
          return e.controls.flatMap((el: any, controlIndex: number) => {
            const isFirst = sectionIndex === 0 && controlIndex === 0;

            const trailingCount = typeof el.value === 'string' && el.value.match(/^(.*\S)\s+(\d+x)$/i);
            let formattedValue: string;
            if (trailingCount) {
              formattedValue = `${trailingCount[2]} ${trailingCount[1]}`;
            } else if (el.value === 'Tak') {
              formattedValue = '1x';
            } else if (typeof el.value === 'string' && !/^\d+x/i.test(el.value)) {
              formattedValue = `1x ${el.value}`;
            } else {
              formattedValue = el.value;
            }

            const quantity = element.cart_positoin.meal_quantity;
            const quantityPrefix = quantity > 1 ? `(${quantity}x) ` : '';

            return [
              {
                style: { marginBottom: "0px", marginTop: isFirst ? "0px" : "6px" },
                texts: [{
                  style: { fontWeight: 300, paddingLeft: "10px", color: "var(--color-text-secondary)" },
                  text: el.name,
                }],
              },
              {
                style: { marginBottom: "0px", marginTop: "0px" },
                texts: [{
                  style: { fontWeight: 300, paddingLeft: "10px" },
                  text: `${quantityPrefix}${formattedValue}`,
                }],
              },
            ];
          });
        });

      const comment = element?.cart_positoin?.description
        ? {
          style: { marginBottom: "0px", marginTop: "2px" },
          texts: [
            {
              style: {
                fontWeight: 300,
              },
              text: `Komentarz: ${element.cart_positoin.description}`,
            },
          ],
        }
        : {
          style: {},
          texts: [
            {
              style: {},
              text: ``,
            },
          ],
        };
      return [product, ...addidton, comment];
    })
    .flat();
};
const createAddressList = (address: any, additionalSections: any) => {
  const addressFE = [
    {
      style: { marginBottom: "3px", marginTop: "8px" },
      texts: [
        {
          style: {
            fontWeight: 500,
          },
          text: "Dane kontaktowe",
        },
      ],
    },
    {
      style: {},
      texts: [
        {
          style: {
            fontWeight: 400,
          },
          text: `Imie i nazwisko: ${address.clientName}`,
        },
      ],
    },
    {
      style: {},
      texts: [
        {
          style: {
            fontWeight: 400,
          },
          text: `Email: ${address.email}`,
        },
      ],
    },
    {
      style: {},
      texts: [
        {
          style: {
            fontWeight: 400,
          },
          text: `Numer telefonu: ${address.telNumber}`,
        },
      ],
    },
  ];
  const additionalSectionsFE = additionalSections
    ?.map((element: any) => {
      const section = {
        style: { marginBottom: "3px", marginTop: "8px" },
        texts: [
          {
            style: {
              fontWeight: 500,
            },
            text: element.sectionName,
          },
        ],
      };
      const controls = element.controls.map((e: any) => {
        return {
          style: { marginBottom: "" },
          texts: [
            {
              style: {
                fontWeight: 400,
              },
              text: `${e.name}: ${e.value}`,
            },
          ],
        };
      });

      return [section, ...controls];
    })
    ?.flat();

  return [...addressFE, ...(additionalSectionsFE || [])];
};

const createCartItems = (cart: any) => {
  return cart.map((element: any) => {
    const addons = element.cart_positoin.meal_options.flatMap((section: any) =>
      section.controls.map((control: any) => {
        const trailingCount =
          typeof control.value === 'string' &&
          control.value.match(/^(.*\S)\s+(\d+x)$/i);
        let formattedValue: string;
        if (trailingCount) {
          formattedValue = `${trailingCount[2]} ${trailingCount[1]}`;
        } else if (control.value === 'Tak') {
          formattedValue = '1x';
        } else if (
          typeof control.value === 'string' &&
          !/^\d+x/i.test(control.value)
        ) {
          formattedValue = `1x ${control.value}`;
        } else {
          formattedValue = control.value as string;
        }
        const quantity = element.cart_positoin.meal_quantity;
        const quantityPrefix = quantity > 1 ? `(${quantity}x) ` : '';
        return {
          categoryName: control.name as string,
          optionText: `${quantityPrefix}${formattedValue}`,
        };
      })
    );

    return {
      qty: element.cart_positoin.meal_quantity as number,
      name: element.cart_positoin.meal_name as string,
      addons,
      comment: (element.cart_positoin.description as string) || null,
    };
  });
};

export const formatedOrderDetails = (element: any) => {
  return {
    id: element.id,
    status: element.status,
    createdAt: element.createdAt,
    updatedAt: element.updatedAt,
    isInternalOrder: element.isInternalOrder,
    header: {
      createdAt: element.createdAt,
      price: element.price,
      paymentsType: element.details.paymentsType,
      paymentsLabel: element.details.payments,
      refund: element.refund,
      appliedCoupon: element.details.appliedCoupon,
    },
    cart: [...createCartList(element.details.cart)],
    cartItems: createCartItems(element.details.cart),
    address: [
      ...createAddressList(element, element.details.additionalSections),
    ],
    footer: {
      deliveryTimeType: element.details.deliveryTimeType,
      deliveryOrderDate: element.details.orderDate,
      deliveryType: element.details.deliveryType,
      deliveryLabel: element.details.deliveryLabel,
      deliveryPlaceId: element.details.deliveryPlaceId,
      deliveryPrice: element.details.deliveryPrice,
      deliveryZone: element.details.deliveryZone,
      apertmenNumber: element.details.apertmenNumber,
      deliveryNote: element.details.deliveryNote,
      tableName: element.details.tableName,
      tableId: element.details.tableId,
    },
  };
};

export const formatAddressWithApartment = (deliveryLabel: string, apartmentNumber?: string): string => {
  if (!apartmentNumber || !deliveryLabel) return deliveryLabel;
  const commaIndex = deliveryLabel.indexOf(',');
  if (commaIndex === -1) return `${deliveryLabel} / ${apartmentNumber}`;
  return `${deliveryLabel.substring(0, commaIndex)} / ${apartmentNumber}${deliveryLabel.substring(commaIndex)}`;
};

export const createOrdersList = (ordersList: any) => {
  if (Array.isArray(ordersList)) {
    return ordersList.map((element) => {
      return formatedOrderDetails(element);
    }) as [];
  }
  return [];
};
